import { render, staticRenderFns } from "./FormResponseType1.vue?vue&type=template&id=53ab3a7e&scoped=true&"
import script from "./FormResponseType1.vue?vue&type=script&lang=js&"
export * from "./FormResponseType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab3a7e",
  null
  
)

export default component.exports